
import React from "react";
import { useNavigate } from "react-router-dom";
import { Create, GetAllDepartments } from "adminApi/UserManageApi/Division";
import Spinner from "Common/Globle/Spinner";
import AddDivisionForm from "./components/AddDivisionForm";
import fields from "../json/Division.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import { DivisionRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";



const AddDivision = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(
    initialValues,
    DivisionRules
  );

  const { data: departments, loading: loadingDepartments } = useFetchAllData(GetAllDepartments);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Create({ data: formValues });
    },
    (vals) => {
      const err = validateForm(vals, DivisionRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Division created successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingDepartments) && <Spinner isSpinner={true} />}
      <AddDivisionForm
        fields={formdata}
        values={values}
        errors={errors}
        departments={departments}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Division"
      />
    </>
  );
};

export default AddDivision;
